
export const queryConfig = {
  // Global
  suspense: false,
  useErrorBoundary: undefined, // Defaults to the value of `suspense` if not defined otherwise
  throwOnError: false,
  refetchAllOnWindowFocus: false,
  // queryKeySerializerFn: (queryKey) => [queryHash, queryFnArgs],
  // onMutate: () => {},
  // onSuccess: () => {},
  // onError: () => {},
  // onSettled: () => {},

  // useQuery
  retry: 3,
  retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  staleTime: 0, //2 * 1000,
  cacheTime: 5 * 60 * 1000,
  refetchInterval: false,
  // queryFnParamsFilter: (args) => filteredArgs,
  // refetchOnMount: true,
  // isDataEqual: (previous, next) => true, // or false
};
